import { connect } from 'react-redux'

import { applyFilter } from '../../redux/modules/search/actions'

import Budget from '../../components/filters/Budget'

const mapStateToProps = (state) => ({
  minBudget: state.search.filters.minBudget || 1,
  maxBudget: state.search.filters.maxBudget || 5,
})

const actionCreators = { applyFilter }

export default connect(mapStateToProps, actionCreators)(Budget)



// WEBPACK FOOTER //
// ./src/containers/filters/Budget.js